import { render, staticRenderFns } from "./Membership.vue?vue&type=template&id=2c1090a7"
import script from "./Membership.vue?vue&type=script&lang=ts"
export * from "./Membership.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../web-ai-translation/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports